import { useEffect, useState } from 'react';
import { AppErrorBoundary } from '../app/AppErrorBoundary';
import { LayoutFrame } from '../app/LayoutFrame';
import { Providers } from '../app/Providers';
import { syntheticDemoPortalsEnabled } from '../shared/config/api-origin';
import { PlatformReleaseStatus } from '../shared/platform/PlatformReleaseStatus';
import { currentPortal } from '../shared/platform/portal-context';
import { AdminApp } from './admin/AdminApp';
import { FirefighterApp } from './firefighter/FirefighterApp';
import { VendorApp } from './vendor/VendorApp';

/** Shared providers and role selection. Each portal owns its own page composition. */
export function AppRoot() {
  const [pathname, setPathname] = useState(() =>
    typeof window === 'undefined' ? '' : window.location.pathname,
  );
  // PortalShell uses history navigation. Subscribe above all three portals so a route change
  // updates their composition without remounting the provider or discarding its session.
  useEffect(() => {
    const readLocation = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', readLocation);
    return () => window.removeEventListener('popstate', readLocation);
  }, []);
  const portal = currentPortal();
  return (
    <AppErrorBoundary>
      <Providers>
        <PlatformReleaseStatus />
        {(portal === 'vendor' || portal === 'admin') && !syntheticDemoPortalsEnabled() ? (
          <LayoutFrame>
            <section aria-label="演示门户访问限制">
              <h1>演示门户尚未开放</h1>
              <p>请在开发环境或明确启用的合成演示环境中访问。</p>
            </section>
          </LayoutFrame>
        ) : portal === 'vendor' ? (
          <VendorApp />
        ) : portal === 'admin' ? (
          <AdminApp />
        ) : (
          <FirefighterApp pathname={pathname} />
        )}
      </Providers>
    </AppErrorBoundary>
  );
}
